import { useEffect, useState } from "react";
import { pendingClosureCount, pendingCount, QUEUE_EVENT } from "@/lib/offlineQueue";

export default function OfflinePendingBar() {
  const [n, setN] = useState(0);
  const [closures, setClosures] = useState(0);

  useEffect(() => {
    const read = () => {
      setN(pendingCount());
      setClosures(pendingClosureCount());
    };
    read();
    window.addEventListener(QUEUE_EVENT, read);
    window.addEventListener("online", read);
    return () => {
      window.removeEventListener(QUEUE_EVENT, read);
      window.removeEventListener("online", read);
    };
  }, []);

  if (!n && !closures) return null;
  const parts = [];
  if (n === 1) parts.push("1 scontrino già stampato");
  else if (n > 1) parts.push(`${n} scontrini già stampati`);
  if (closures === 1) parts.push("1 chiusura già uscita sulla fiscale");
  else if (closures > 1) parts.push(`${closures} chiusure già uscite sulla fiscale`);
  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-[#B45309] text-white text-center text-sm font-medium px-3 py-2">
      {parts.join(" · ")}. In attesa della linea per il server.
    </div>
  );
}
